import { Badge, Box, HStack, Icon, Text } from "@chakra-ui/react";
import React from "react";
import { FiGlobe } from "react-icons/fi";

interface ABTestDomainSelectionProps {
  domain: string;
  onChange: (domain: string) => void;
  disabled?: boolean;
}

export const ABTestDomainSelection: React.FC<ABTestDomainSelectionProps> = ({
  domain,
  onChange,
  disabled = false
}) => {
  return (
    <Box bg="white" shadow="sm" rounded="lg" p={6}>
      <HStack mb={4}>
        <Icon as={FiGlobe} color="blue.500" boxSize={5} />
        <Text fontWeight="semibold" fontSize="lg">
          Select Domain
        </Text>
        <Badge colorScheme="red" size="sm">
          Required
        </Badge>
      </HStack>
      <Box>
        <Text fontSize="sm" fontWeight="medium" mb={2}>
          Main Domain
        </Text>
        <select
          value={domain}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          style={{
            width: "100%",
            padding: "0.75rem",
            fontSize: "1rem",
            borderRadius: "0.375rem",
            border: "1px solid #CBD5E0",
            backgroundColor: "white"
          }}
        >
          <option value="zown.ca">zown.ca</option>
          <option value="zownhomes.com">zownhomes.com</option>
        </select>
        <Text fontSize="sm" color="gray.500" mt={2}>
          Select the main domain for your website variants and paths
        </Text>
      </Box>
    </Box>
  );
};
